import { Space, Typography, Card } from "antd";
import React, { useEffect } from "react";
import SapaHeader from "../../ui/Header/Header";
import DashboardLineChart, { DashboardBarChart, DashboardDoughnutChart } from "./Dashboard-LineChart";
import DashboardCard from "./DashboardCard";
import legend from "../../assets/media-icons/Group 1.png";
import calendar from "../../assets/svgs/Dashboard-icons/calendar.svg";
import ProgressLoader from "../../components/Loader/ProgressLoader";
import { useDispatch, useSelector } from "react-redux";
import { selectDashboardLoading, selectDashboardStatistics } from "../../redux/selectors/dashboardSelectors";
import { fetchDashboardStatistics } from './../../redux/actions/dashboard';
import ActionHandler from "../../components/ActionHandler/ActionHandler";
//import { ChartData } from './../../DummyAPI/ChartData/ChartData';


const Dashboard = () => {
  const dispatch = useDispatch();
  const dStats = useSelector(selectDashboardStatistics);
  const isLoading = useSelector(selectDashboardLoading);

  const chartData = dStats?.revenue_chart || [];
  const walletTotals = dStats?.wallet_totals || {};
  const transactionStatusData = [
    dStats?.successful_transaction_count || 0,
    dStats?.pending_transaction_count || 0,
    dStats?.failed_transaction_count || 0,
  ];
  const serviceBreakdown = dStats?.service_breakdown || [];
  const money = (value) =>
    `₦ ${Number(value || 0).toLocaleString("en-NG", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  const percent = (value) => `${Number(value || 0).toLocaleString("en-NG", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}%`;

  const statsData = {
    labels: chartData.map((data) => data.month),
    datasets: [
      {
        label: "Profit",
        data: chartData.map((data) => data.profit),
        borderColor: "#318D1F",
      },
      {
        label: "Revenue",
        data: chartData.map((data) => data.revenue),
        borderColor: "#2F75FF",
      },
    ],
  };

  const statusChartData = {
    labels: ["Successful", "Pending", "Failed"],
    datasets: [
      {
        label: "Transactions",
        data: transactionStatusData,
        backgroundColor: ["#12B76A", "#F79009", "#F04438"],
      },
    ],
  };

  const serviceChartData = {
    labels: serviceBreakdown.map((item) => item.service || "Unassigned"),
    datasets: [
      {
        label: "Transactions",
        data: serviceBreakdown.map((item) => item.total || 0),
        backgroundColor: ["#1C7CF5", "#12B76A", "#F79009", "#7A5AF8", "#06AED4"],
      },
    ],
  };


  useEffect(() => {
    dispatch(fetchDashboardStatistics());
  }, [dispatch]);


  return (
    <ProgressLoader isLoading={isLoading}>
      <div className="Dashboard">
        <SapaHeader page="Dashboard" />
        <Space
          className="sapa-dashboard__topSection"
          direction="vertical"
          size={24}
        >
          <Typography.Text>Overview</Typography.Text>
          <div className="sapa-dashboard-card__container">
            <DashboardCard
              title="Total Income"
              value={money(dStats?.total_income)}
            />
            <DashboardCard
              title="Total Transactions"
              value={`${dStats?.total_transactions || 0}`}
            />
            <DashboardCard
              title="Total Users"
              value={dStats?.total_users || 0}
            />
            <DashboardCard
              title="Operating Profit"
              value={money(dStats?.profit_margin)}
            />
            <DashboardCard
              title="Profit Margin"
              value={percent(dStats?.profit_margin_percentage)}
            />
            <DashboardCard
              title="Recorded Profit"
              value={money(dStats?.recorded_profit)}
            />
            <DashboardCard
              title="Estimated Profit"
              value={money(dStats?.estimated_profit)}
            />
            <DashboardCard
              title="User Wallets"
              value={money(walletTotals?.main_balance)}
            />
            <DashboardCard
              title="Withdrawable Wallets"
              value={money(walletTotals?.withdrawable_balance)}
            />
            <DashboardCard
              title="Payout Wallets"
              value={money(walletTotals?.payout_balance)}
            />
            <DashboardCard
              title="Commission Wallets"
              value={money(walletTotals?.commission_balance)}
            />
            <DashboardCard
              title="Wallet Liability"
              value={money(dStats?.total_wallet_liability)}
            />
            <DashboardCard
              title="Provider Balances"
              value={money(dStats?.provider_balance_total)}
            />
            <DashboardCard
              title="Successful Tx"
              value={`${dStats?.successful_transaction_count || 0}`}
            />
            <DashboardCard
              title="Pending Tx"
              value={`${dStats?.pending_transaction_count || 0}`}
            />
            <DashboardCard
              title="Failed Tx"
              value={`${dStats?.failed_transaction_count || 0}`}
            />
            <DashboardCard
              title="Deposits"
              value={money(dStats?.total_deposits)}
            />
            <DashboardCard
              title="Withdrawals"
              value={money(dStats?.total_withdrawals)}
            />
          </div>
        </Space>
        <Space
          className="sapa-dashboard__topSection"
          direction="vertical"
          size={24}
        >
          <Typography.Text>Income Flow</Typography.Text>
          <Card className="sapa-dashboard__lowerSection">
            <div className="sapa-dashboard__legend_container" style={{marginBottom: 32, marginTop: 16}}>
              <img className="chart-img" src={legend} alt="/" />
              <ActionHandler
                isDropdown={true}
                customIcon={<img className="calendar-icon" src={calendar} alt="/" />}
                items={[
                  { label: "All", value: "all" },
                  { label: "Last Week", value: "last_week"},
                  { label: "Last Month", value: "last_month" },
                  { label: "Last 6 Months", value: "last_6_months" },
                  { label: "Last Year", value: "last_year"}
                ]}
                callback={(e) => {
                  dispatch(fetchDashboardStatistics({date: e?.value}))
                }}
              />
            </div>
            <DashboardLineChart chartData={statsData} />
          </Card>
        </Space>
        <div className="sapa-dashboard__chartGrid">
          <Card className="sapa-dashboard__chartCard">
            <Typography.Text>Transaction Status</Typography.Text>
            <DashboardDoughnutChart chartData={statusChartData} />
          </Card>
          <Card className="sapa-dashboard__chartCard">
            <Typography.Text>Service Volume</Typography.Text>
            <DashboardBarChart chartData={serviceChartData} />
          </Card>
        </div>
      </div>
    </ProgressLoader>
  );
};

export default Dashboard;
